import { useOfferFiltersState } from "../context/OfferFiltersContext";
import { isFilterVisible } from "../utils/isFilterVisible";
import FilterSection from "./FilterSection";
import SortSection from "./SortSection";
import StaticFilterSection from "./StaticFilterSection";
import React, { useState } from "react";
export default function FilterAccordion() {
    var _a, _b;
    const { filterConfig, pathFilters, facetData, overlayOpenedVia } = useOfferFiltersState();
    const [openId, setOpenId] = useState(() => overlayOpenedVia === "sort"
        ? "__sort__"
        : pathFilters.length > 0
            ? "__path_filters__"
            : null);
    const items = filterConfig.filter((f) => f.type !== "hidden" && f.facet_group != null);
    return (<div className="flex-1 overflow-y-auto flex flex-col">
      <div className="divide-y divide-gray-200 px-4">
        <SortSection isOpen={openId === "__sort__"} onToggle={() => setOpenId((prev) => (prev === "__sort__" ? null : "__sort__"))}/>
        {pathFilters.length > 0 && (<StaticFilterSection label={(_b = (_a = pathFilters[0]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ""} filters={pathFilters} isOpen={openId === "__path_filters__"} onToggle={() => setOpenId((prev) => prev === "__path_filters__" ? null : "__path_filters__")}/>)}
        {items.map((filter) => {
            const facet = filter.facet_group != null
                ? facetData[filter.facet_group]
                : undefined;
            if (!isFilterVisible(filter, facet))
                return null;
            return (<FilterSection key={filter.id} filter={filter} facet={facet} isOpen={openId === filter.id} onToggle={() => setOpenId((prev) => (prev === filter.id ? null : filter.id))}/>);
        })}
      </div>
    </div>);
}
